import { useMe } from "../me";
// @ts-ignore
import { finished, offers, planned } from "../routes";

export function tabs(me: ReturnType<typeof useMe>) {
  return [
    {
      labelId: "rides.offers",
      link: offers({ userRoles: me.roles }),
      isSelectedMatchers: [offers()],
    },
    {
      labelId: "rides.planned",
      link: planned({ userRoles: me.roles }),
      isSelectedMatchers: [planned()],
    },
    {
      labelId: "rides.finished",
      link: finished({ userRoles: me.roles }),
      isSelectedMatchers: [finished()],
    },
  ];
}
